import { Button } from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useTranslate } from 'src/locales';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function DialogLogout({ open, onClose }: Props) {
  const { logout } = useAuthContext();
  const { t: tSystem } = useTranslate('system');

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title={tSystem('dialog.logout.title')}
      content={tSystem('dialog.logout.content')}
      action={
        <Button variant="contained" onClick={logout} color="inherit">
          {tSystem('dialog.logout.confirm')}
        </Button>
      }
    />
  );
}
